'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./product/quickView'));

    $('.pagination-links').find('.show-more.active').prev('.show-more').addClass('active-sibling');
    $('.pagination-links').find('.pagination-link').removeAttr('aria-disabled');
    $('.pagination-links').find('.pagination-link.disabled').attr('aria-disabled',true);
});
